import { CoachingExplanation }
  from "@/components/coaching/CoachingExplanation";
import { CoachingSectionCard }
  from "@/components/coaching/CoachingSectionCard";

import { SportBadge } from "@/components/SportBadge";

export const WorkoutFocusCard = ({ explanation, error, todaySession }) => {
  const isEmpty = !error && (!explanation
                                    || (explanation.message_keys || []).length === 0);
  const sport = todaySession?.sport;
  return (
    <CoachingSectionCard
      title="What to focus on"
      subtitle="Structured targets for today's session"
      headingId="coaching-focus-heading"
      testId="coaching-focus-card"
      error={error}
      empty={isEmpty ? "No structured targets available." : null}
      actions={sport ? <SportBadge sport={sport} /> : null}
      elevated
    >
      {!isEmpty && (
        <CoachingExplanation
          explanation={explanation}
          testId="focus-explanation"
        />
      )}
    </CoachingSectionCard>
  );
};
